__turbopack_context__.v({
  "blockName": "account-details-form-block-module-sass-module__EPbI-a__blockName",
  "header": "account-details-form-block-module-sass-module__EPbI-a__header",
  "infoForm": "account-details-form-block-module-sass-module__EPbI-a__infoForm",
  "opened": "account-details-form-block-module-sass-module__EPbI-a__opened",
  "overflowVisible": "account-details-form-block-module-sass-module__EPbI-a__overflowVisible",
  "userInfoNotification": "account-details-form-block-module-sass-module__EPbI-a__userInfoNotification",
});
